export default {
    baseStyle: {
        orderTitle: {
            color: 'black',
            fontSize: '26px',
            fontWeight: 'extrabold',
            lineHeight: 'normal',
            margin: '0',
            fontFamily: 'crunchyrollatyp bold'
        },
        orderSummaryLabel: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'normal',
            fontSize: 'md'
        },
        orderSummaryAmount: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'bold',
            color: 'black',
            fontSize: 'md'
        },
        promoCodeLabel: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: 'normal'
        },
        orderSummaryTotal: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'extrabold',
            fontSize: 'xl',
            lineHeight: 7
        },
        shippingDiscounts: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'bold',
            fontSize: 'md',
            color: 'darkGreen',
            lineHeight: 'normal'
        },
        promoCodeBlock: {
            borderWidth: '1px 0',
            py: 3,
            my: 3,
            borderStyle: 'solid',
            borderColor: 'softSand',
            w: 'full'
        }
    }
}
